//通用函数库
// 通用方法

import cookies from './util.cookies'
import db from './util.db'
import fs from 'fs';
import path from 'path';
import {Message} from 'element-ui'

const util = {
  cookies,
  db,
}

util.toSnakeString = (name) => {
  return name.replace(/\B([A-Z])/g, '_$1').toLowerCase()
}


// 创建一个错误
util.errorCreate = (msg) => {
  // 显示提示
  // eslint-disable-next-line no-undef
  Message.error(msg);
}

//获取主要路径
util.getMainPath = () => {
  let execPath = path.dirname(remote.process.execPath);
  let pathArr = execPath.split('/');
  let resPath = [];
  for (let i = 0; i < pathArr.length; i++) {
    if (pathArr[i].startsWith('ChromoSeek') || pathArr[i].startsWith('LGG') || pathArr[i].startsWith('HKU-laboratory')) {
      resPath.push(pathArr[i]);
      break;
    } else {
      resPath.push(pathArr[i]);
    }
  }
  return resPath.join('/');
}

/**
 * 导出
 * @param {object} params 参数
 */
util.downloadFile = (params, name, api) => {
  // 获取接口基础路径
  const apiBaseUrl = util.getApiBaseUrl();
  // 拼接参数
  const paramsString = Object.keys(params).map(key => {
    return `${key}=${params[key]}`;
  }).join('&');
  // 构造 a 标签
  let link = document.createElement('a');
  link.style.display = 'none';
  link.href = `${apiBaseUrl}${api}?${paramsString}`;
  link.download = name;
  document.body.appendChild(link);
  // 执行下载
  link.click();
}

util.delteDirall = (path) => {
  let files = [];
  if (fs.existsSync(path)) {
    files = fs.readdirSync(path);
    files.forEach((file, index) => {
      let curPath = path + "/" + file;
      if (fs.statSync(curPath).isDirectory()) {
        this.delteDirall(curPath);
      } else {
        fs.unlinkSync(curPath);
      }
    });
    fs.rmdirSync(path);
  }
}

util.compare = (a, b) => {
  if (a.chr < b.chr) {
    return -1;
  } else if (a.chr === b.chr) {
    if (a.start < b.start) {
      return -1;
    } else if (a.start > b.start) {
      return 1;
    } else {
      return 0;
    }
  } else {
    return 0;
  }
}

util.binarySearch = (value, data, expandRow, type) => {
  let mi = 1, mx = data.length, res = 0;
  while (mi <= mx) {
    let mid = (mi + mx) >> 1;
    if (data[mid - 1][0] <= value) {
      res = mid - 1;
      mi = mid + 1;
    } else {
      mx = mid - 1;
    }
  }
  if (type === 'left') {
    //当两点距离大于1m，则抛弃
    let ans = res;
    for (let i = res; i > Math.max(0, res - expandRow); i--) {
      ans = i;
      if (data[i][0] - data[i - 1][0] > 1000000) {
        break;
      }
    }
    return ans;
  } else {
    let ans = res;
    for (let i = res; i < Math.min(res + expandRow, data.length - 1); i++) {
      ans = i;
      if (data[i + 1][0] - data[i][0] > 1000000) {
        break;
      }
    }
    return ans;
  }
}

util.getBand = (bandData, st, ed) => {
  let first = null;
  let end = '';
  bandData.forEach(one => {
    if (st >= one.start && st <= one.end || st <= one.start && ed >= one.end || one.start <= ed && ed <= one.end) {
      if (first !== null) {
        end = one.band;
      }
      if (first === null) {
        first = one.band;
      }
    }
  });
  return first + end;
}

util.drawInit = () => {
  return {
    chart: {
      zoomType: 'x'
    },
    title: {
      text: '数据正在加载中，请等待'
    },
    xAxis: {
      title: {
        enabled: true,
        text: 'location'
      },
      min: 1,
    },
    yAxis: {
      title: {
        text: 'copy-ratio'
      },
      min: 0.0,
      max: 3.0
    },
    boost: {
      useGPUTranslations: true,
      usePreAllocated: true
    },
    tooltip: {
      enabled: false
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 1.5,
          states: {
            hover: {
              enabled: true,
              lineColor: 'rgb(100,100,100)'
            }
          }
        },
        states: {
          hover: {
            marker: {
              enabled: false
            }
          }
        }
      }
    },
    series: [{
      type: 'scatter',
      color: 'black',
      data: []
    }]
  };
}

util.getWin1ClickArea = (chr) => {
  return [
    [
      {
        xAxis: parseInt(chr) - 0.5,
        itemStyle: {
          color: 'grey',
          opacity: 0.4
        }
      },
      {
        xAxis: parseInt(chr) + 0.5,
      }
    ]
  ];
}

util.getAreaData = (start, end, chr, area, win5Data, sexAreaSeries) => {
  let areaData = [];
  let shadow = 2;
  if (chr > 22) shadow = 3;
  // console.log(shadow);
  // console.log(sexAreaSeries);
  area.forEach(one => {
    let st = one[0].coord[0];
    let ed = one[1].coord[0];
    let color = one[0].itemStyle.color;

    if (st <= start && ed >= end) {
      let mid = (start + end) >> 1;
      areaData.push([
        {
          coord: [st, -0.32],
          symbolSize: 0,
          itemStyle: {
            color: color
          }
        },
        {
          coord: [mid, -0.5],
          symbolSize: 0,
        }
      ]);
      areaData.push([
        {
          coord: [mid, -0.32],
          symbolSize: 0,
          itemStyle: {
            color: color
          }
        },
        {
          coord: [ed, -0.5],
          symbolSize: 0,
        }
      ]);
    } else {
      areaData.push(one);
    }
  });
  win5Data.forEach(one => {
    let st = one.start;
    let ed = one.end;
    let color = 'red';
    if (one.copyRatio !== undefined && Number(one['copyRatio']) > 1) {
      color = 'blue';
    }
    if (one.color !== undefined) {
      color = one.color;
      shadow = 3.5;
    }
    if (parseInt(chr) === parseInt(one.chr) || (parseInt(chr) === 23 && one.chr === 'X') || (parseInt(chr) === 24 && one.chr === 'Y')) {
      if (st <= start && ed >= end) {
        let mid = (start + end) >> 1;
        areaData.push([
          {
            coord: [st, shadow],
            symbolSize: 0,
            itemStyle: {
              color: color,
              opacity: 0.4
            }
          },
          {
            coord: [mid, 0],
            symbolSize: 0,
          }
        ]);
        areaData.push([
          {
            coord: [mid, shadow],
            symbolSize: 0,
            itemStyle: {
              color: color,
              opacity: 0.4
            }
          },
          {
            coord: [ed, 0],
            symbolSize: 0,
          }
        ]);
      } else {
        areaData.push([
          {
            xAxis: st,
            yAxis: shadow,
            symbolSize: 0,
            itemStyle: {
              color: color,
              opacity: 0.4
            }
          },
          {
            xAxis: ed,
            yAxis: 0,
            symbolSize: 0,
          }
        ]);
      }
    }
  });
  sexAreaSeries.forEach(one => {
    let st = one.start;
    let ed = one.end;
    let color = one.color;
    let left = one.colorAxis[0];
    let right = one.colorAxis[1];
    if (st <= start && ed >= end) {
      let mid = (start + end) >> 1;
      areaData.push([
        {
          coord: [st, left],
          symbolSize: 0,
          itemStyle: {
            color: color
          }
        },
        {
          coord: [mid, right],
          symbolSize: 0,
        }
      ]);
      areaData.push([
        {
          coord: [mid, left],
          symbolSize: 0,
          itemStyle: {
            color: color
          }
        },
        {
          coord: [ed, right],
          symbolSize: 0,
        }
      ]);
    } else {
      areaData.push([
        {
          coord: [st, left],
          symbolSize: 0,
          itemStyle: {
            color: color
          }
        },
        {
          coord: [ed, right],
          symbolSize: 0,
        }
      ]);
    }
  });
  return areaData;
}

util.Appendzero = (obj) => {
  if (obj < 10) return "0" + "" + obj;
  else return obj;
}

util.Deletezero = (str) => {
  if (str[0] === '0') {
    return str.substring(1);
  } else {
    return str;
  }
}

util.getNowDateTime = () => {
  let date = new Date();
  return date.getFullYear() + '-' + util.Appendzero(date.getMonth() + 1) + '-' + util.Appendzero(date.getDate()) + ' ' + util.Appendzero(date.getHours()) + ':' + util.Appendzero(date.getMinutes()) + ':' + util.Appendzero(date.getSeconds());
}

util.cytoBandInit = () => {
  let colorMap = {
    gneg: 'white',
    gpos: 'lightgrey',
    gpos25: 'grey',
    gpos50: 'grey',
    gpos75: 'darkgrey',
    gpos100: 'black',
    acen: 'red',
    gvar: 'turquoise4',
    stalk: 'white'
  }
  let resChr = {};
  let bandData = {};
  let chrLineMi = {};
  let chrLineMx = {};
  let areaChrArr = areaChr.split('\n');
  const areaChrLen = areaChrArr.length;
  for (let i = 0; i < areaChrLen; i++) {
    let line = areaChrArr[i];
    let one = line.split('\t');
    let chr = one[0]
    if (!resChr.hasOwnProperty(chr)) {
      resChr[chr] = [];
      bandData[chr] = [];
      resChr[chr][0] = [];
      resChr[chr][1] = [];
      resChr[chr][2] = {};
      chrLineMi[chr] = parseInt(one[1]);
      chrLineMx[chr] = parseInt(one[1]);
    }
    bandData[chr].push({
      start: parseInt(one[1]),
      end: parseInt(one[2]),
      band: one[3],
      color: one[4]
    });
    let color = colorMap[one[4]];
    chrLineMi[chr] = Math.min(chrLineMi[chr], parseInt(one[1]));
    chrLineMi[chr] = Math.min(chrLineMi[chr], parseInt(one[2]));
    chrLineMx[chr] = Math.max(chrLineMx[chr], parseInt(one[1]));
    chrLineMx[chr] = Math.max(chrLineMx[chr], parseInt(one[2]));
    resChr[chr][0].push(
      [
        {
          coord: [parseInt(one[1]), 1],
          symbolSize: 0,
          band: one[3],
          itemStyle: {
            color: color
          }
        },
        {
          coord: [parseInt(one[2]), 0],
          symbolSize: 0,
        }
      ]
    );
    resChr[chr][1].push(
      [
        {
          coord: [parseInt(one[1]), 1],
          symbol: "none",
        },
        {
          coord: [parseInt(one[1]), 0],
          symbol: "none",
        }
      ]
    );
    resChr[chr][1].push(
      [
        {
          coord: [parseInt(one[2]), 1]
        },
        {
          coord: [parseInt(one[2]), 0]
        }
      ]
    );
  }
  for (const theChr of Object.keys(chrLineMi)) {
    resChr[theChr][1].push(
      {
        yAxis: 1,
        xAxis: 'max',
      }
    );
    resChr[theChr][1].push(
      {
        yAxis: 0,
        xAxis: 'max',
      }
    );
    resChr[theChr][2]['min'] = chrLineMi[theChr];
    resChr[theChr][2]['max'] = chrLineMx[theChr];
  }
  return resChr;
}

util.getCytoBandArea = (start, end, chr, area) => {
  let areaData = [];
  area.forEach(one => {
    let st = one[0].coord[0];
    let ed = one[1].coord[0];
    let color = one[0].itemStyle.color;

    if (st <= start && ed >= end) {
      let mid = (start + end) >> 1;
      areaData.push([
        {
          coord: [st, 1],
          symbolSize: 0,
          itemStyle: {
            color: color
          }
        },
        {
          coord: [mid, 0],
          symbolSize: 0,
        }
      ]);
      areaData.push([
        {
          coord: [mid, 1],
          symbolSize: 0,
          itemStyle: {
            color: color
          }
        },
        {
          coord: [ed, 0],
          symbolSize: 0,
        }
      ]);
    } else {
      areaData.push(one);
    }
  });
  return areaData;
};

util.getCytoBandAreaByDefault = (area, initColor) => {
  let areaData = [];
  area.forEach(one => {
    let st = one[0].coord[0];
    let ed = one[1].coord[0];
    let color = one[0].itemStyle.color;
    if (color === "lightgrey") {
      const regex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
      const match = initColor.match(regex);
      const red = parseInt(match[1]);
      const green = parseInt(match[2]);
      const blue = parseInt(match[3]);
      color = `rgba(${red}, ${green}, ${blue}, 0.5)`;
    } else if (color === "grey") {
      const regex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
      const match = initColor.match(regex);
      const red = parseInt(match[1]);
      const green = parseInt(match[2]);
      const blue = parseInt(match[3]);
      color = `rgba(${red}, ${green}, ${blue}, 0.75)`;
    } else if (color !== "white") {
      color = initColor;
    }
    one[0].itemStyle.color = color;
    // console.log(color);
    areaData.push(one);
  });
  return areaData;
}

util.getCytoBandAreaByInv = (area, initColor, band1, band2) => {
  let areaData = [];

  function getColor(color, initColor) {
    if (color === "lightgrey") {
      const regex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
      const match = initColor.match(regex);
      const red = parseInt(match[1]);
      const green = parseInt(match[2]);
      const blue = parseInt(match[3]);
      return `rgba(${red}, ${green}, ${blue}, 0.5)`;
    } else if (color === "grey") {
      const regex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
      const match = initColor.match(regex);
      const red = parseInt(match[1]);
      const green = parseInt(match[2]);
      const blue = parseInt(match[3]);
      return `rgba(${red}, ${green}, ${blue}, 0.75)`;
    } else if (color !== "white") {
      return initColor;
    } else {
      return color;
    }
  }

  let newArea1 = [], newArea2 = [], newArea3 = [];
  let index1 = 0, index2 = 0;
  for (let i = 0; i < area.length; i++) {
    newArea1.push(area[i]);
    if (area[i][0].band === band1) {
      index1 = i;
      break;
    }
  }
  for (let i = 0; i < area.length; i++) {
    if (area[i][0].band === band2) {
      index2 = i;
      break;
    }
  }
  for (let i = index1 + 1; i < index2; i++) {
    newArea2.push(area[i]);
  }
  for (let i = index2; i < area.length; i++) {
    newArea3.push(area[i]);
  }


  for (let i = 0; i < newArea1.length; i++) {
    areaData.push(newArea1[i]);
  }
  let position = newArea1[newArea1.length - 1][1]['coord'][0];
  for (let i = newArea2.length - 1; i >= 0; i--) {
    const diff = newArea2[i][1]['coord'][0] - newArea2[i][0]['coord'][0];
    newArea2[i][0]['coord'][0] = position;
    newArea2[i][1]['coord'][0] = position + diff;
    position += diff;
    areaData.push(newArea2[i]);
  }
  for (let i = 0; i < newArea3.length; i++) {
    areaData.push(newArea3[i]);
  }
  return areaData;
}


util.getCytoBandAreaByBca = (area, initColor, changeArea, band1, band2, changeColor) => {

  function getColor(color, initColor) {
    if (color === "lightgrey") {
      const regex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
      const match = initColor.match(regex);
      const red = parseInt(match[1]);
      const green = parseInt(match[2]);
      const blue = parseInt(match[3]);
      return `rgba(${red}, ${green}, ${blue}, 0.5)`;
    } else if (color === "grey") {
      const regex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
      const match = initColor.match(regex);
      const red = parseInt(match[1]);
      const green = parseInt(match[2]);
      const blue = parseInt(match[3]);
      return `rgba(${red}, ${green}, ${blue}, 0.75)`;
    } else if (color !== "white") {
      return initColor;
    } else {
      return color;
    }
  }

  // console.log(area, changeArea);
  let areaData = [];
  let colorMap = {
    gneg: 'white',
    gpos: 'lightgrey',
    gpos25: 'grey',
    gpos50: 'grey',
    gpos75: 'darkgrey',
    gpos100: 'black',
    acen: 'red',
    gvar: 'turquoise4',
    stalk: 'white'
  }
  let newArea1 = [], newArea2 = [];
  if (band1.startsWith("p") && band2.startsWith("q")) {
    let index = 0;
    for (let i = 0; i < area.length; i++) {
      if (area[i][0].band === band1) {
        index = i;
        break;
      }
    }
    for (let i = index; i < area.length; i++) {
      area[i][0].itemStyle.color = getColor(area[i][0].itemStyle.color, initColor);
      newArea2.push(JSON.parse(JSON.stringify(area[i])));
    }
    for (let i = changeArea.length - 1; i >= 0; i--) {
      changeArea[i][0].itemStyle.color = getColor(changeArea[i][0].itemStyle.color, changeColor);
      newArea1.push(JSON.parse(JSON.stringify(changeArea[i])));
      if (changeArea[i][0].band === band2) {
        break;
      }
    }
  } else if (band1.startsWith("q") && band2.startsWith("p")) {
    for (let i = 0; i < area.length; i++) {
      if (area[i][0].band === band1) {
        break;
      }
      area[i][0].itemStyle.color = getColor(area[i][0].itemStyle.color, initColor);
      newArea1.push(JSON.parse(JSON.stringify(area[i])));
    }
    let index = 0;
    for (let i = 0; i < changeArea.length; i++) {
      if (changeArea[i][0].band === band2) {
        index = i;
        break;
      }
    }
    for (let i = index; i >= 0; i--) {
      changeArea[i][0].itemStyle.color = getColor(changeArea[i][0].itemStyle.color, changeColor);
      newArea2.push(JSON.parse(JSON.stringify(changeArea[i])));
    }
  } else if (band1.startsWith("p") && band2.startsWith("p")) {
    let index = 0;
    for (let i = 0; i < area.length; i++) {
      if (area[i][0].band === band1) {
        index = i;
        break;
      }
    }
    for (let i = index; i < area.length; i++) {
      area[i][0].itemStyle.color = getColor(area[i][0].itemStyle.color, initColor);
      newArea2.push(JSON.parse(JSON.stringify(area[i])));
    }
    for (let i = 0; i < changeArea.length; i++) {
      changeArea[i][0].itemStyle.color = getColor(changeArea[i][0].itemStyle.color, changeColor);
      newArea1.push(JSON.parse(JSON.stringify(changeArea[i])));
      if (changeArea[i][0].band === band2) {
        break;
      }
    }
  } else {
    for (let i = 0; i < area.length; i++) {
      if (area[i][0].band === band1) {
        break;
      }
      area[i][0].itemStyle.color = getColor(area[i][0].itemStyle.color, initColor);
      newArea1.push(JSON.parse(JSON.stringify(area[i])));
    }
    let index = 0;
    for (let i = 0; i < changeArea.length; i++) {
      if (changeArea[i][0].band === band2) {
        index = i;
        break;
      }
    }
    for (let i = index; i < changeArea.length; i++) {
      changeArea[i][0].itemStyle.color = getColor(changeArea[i][0].itemStyle.color, changeColor);
      newArea2.push(JSON.parse(JSON.stringify(changeArea[i])));
    }
  }

  //p开头先， q开头q的坐标不变
  if (band1.startsWith("p")) {
    let position = newArea2[0][0]['coord'][0];
    for (let i = newArea1.length - 1; i >= 0; i--) {
      const diff = newArea1[i][1]['coord'][0] - newArea1[i][0]['coord'][0];
      newArea1[i][0]['coord'][0] = position - diff;
      newArea1[i][1]['coord'][0] = position;
      position -= diff;
      areaData.push(newArea1[i]);
    }
    for (let i = 0; i < newArea2.length; i++) {
      areaData.push(newArea2[i]);
    }
  } else {
    for (let i = 0; i < newArea1.length; i++) {
      areaData.push(newArea1[i]);
    }
    let position = newArea1[newArea1.length - 1][1]['coord'][0];
    for (let i = 0; i < newArea2.length; i++) {
      const diff = newArea2[i][1]['coord'][0] - newArea2[i][0]['coord'][0];
      newArea2[i][0]['coord'][0] = position;
      newArea2[i][1]['coord'][0] = position + diff;
      position += diff;
      areaData.push(newArea2[i]);
    }
  }
  // console.log(newArea1, newArea2, areaData);
  return areaData;
};

util.getSvsRatioArrawLine = (strand, pointLeft, pointRight) => {
  let lineSeries = [];
  const strandLeft = strand[0];
  const strandRight = strand[2]
  const leftLength = pointLeft[pointLeft.length - 1] - pointLeft[0];
  const rightLength = pointRight[pointRight.length - 1] - pointRight[0];
  const standardNum = pointLeft[pointLeft.length - 1] || 0;
  const standardNextStart = pointRight[0] || 0;
  const diff = standardNum - standardNextStart;

  const p1 = 1.5, p2 = 1.25, p3 = 1, p4 = 0.75, p5 = 0.5;
  if (strandLeft === "-") {
    lineSeries.push([
      {
        coord: [pointLeft[0], p3],
        symbol: "none",
      },
      {
        coord: [pointLeft[0] + leftLength / 4, p1],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[0], 1],
        symbol: "none",
      },
      {
        coord: [pointLeft[0] + leftLength / 4, p5],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[0] + leftLength / 4, p1],
        symbol: "none",
      },
      {
        coord: [pointLeft[0] + leftLength / 4, p2],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[0] + leftLength / 4, p5],
        symbol: "none",
      },
      {
        coord: [pointLeft[0] + leftLength / 4, p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[0] + leftLength / 4, p2],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1], p2],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[0] + leftLength / 4, p4],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1], p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[pointLeft.length - 1], p2],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1], p4],
        symbol: "none",
      }
    ]);
  } else {
    lineSeries.push([
      {
        coord: [pointLeft[0], p2],
        symbol: "none",
      },
      {
        coord: [pointLeft[0], p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[0], p2],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1] - leftLength / 4, p2],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[0], p4],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1] - leftLength / 4, p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[pointLeft.length - 1] - leftLength / 4, p2],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1] - leftLength / 4, p1],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[pointLeft.length - 1] - leftLength / 4, p4],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1] - leftLength / 4, p5],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[pointLeft.length - 1] - leftLength / 4, p1],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1], p3],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointLeft[pointLeft.length - 1] - leftLength / 4, p5],
        symbol: "none",
      },
      {
        coord: [pointLeft[pointLeft.length - 1], p3],
        symbol: "none",
      }
    ]);
  }
  if (strandRight === "-") {
    lineSeries.push([
      {
        coord: [pointRight[0] + diff, p2],
        symbol: "none",
      },
      {
        coord: [pointRight[0] + diff, p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[0] + diff, p4],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] - rightLength / 4 + diff, p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[0] + diff, p2],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] - rightLength / 4 + diff, p2],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[pointRight.length - 1] - rightLength / 4 + diff, p2],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] - rightLength / 4 + diff, p1],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[pointRight.length - 1] - rightLength / 4 + diff, p5],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] - rightLength / 4 + diff, p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[pointRight.length - 1] + diff, p3],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] - rightLength / 4 + diff, p5],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[pointRight.length - 1] + diff, p3],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] - rightLength / 4 + diff, p1],
        symbol: "none",
      }
    ]);
  } else {
    lineSeries.push([
      {
        coord: [pointRight[0] + rightLength / 4 + diff, p1],
        symbol: "none",
      },
      {
        coord: [pointRight[0] + diff, p3],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[0] + rightLength / 4 + diff, p5],
        symbol: "none",
      },
      {
        coord: [pointRight[0] + diff, p3],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[0] + rightLength / 4 + diff, p5],
        symbol: "none",
      },
      {
        coord: [pointRight[0] + rightLength / 4 + diff, p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[0] + rightLength / 4 + diff, p2],
        symbol: "none",
      },
      {
        coord: [pointRight[0] + rightLength / 4 + diff, p1],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[0] + rightLength / 4 + diff, p4],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] + diff, p4],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[0] + rightLength / 4 + diff, p2],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] + diff, p2],
        symbol: "none",
      }
    ]);
    lineSeries.push([
      {
        coord: [pointRight[pointRight.length - 1] + diff, p4],
        symbol: "none",
      },
      {
        coord: [pointRight[pointRight.length - 1] + diff, p2],
        symbol: "none",
      }
    ]);

  }
  return lineSeries;
}

util.getArrawLeftData = (strand, pointLeft, pointRight) => {
  let data = [];
  let lineSeries = [];
  const strandLeft = strand[0];
  const strandRight = strand[2]
  const leftLength = pointLeft[pointLeft.length - 1] - pointLeft[0];
  const rightLength = pointRight[pointRight.length - 1] - pointRight[0];
  const standardNum = pointLeft[pointLeft.length - 1] || 0;
  const standardNextStart = pointRight[0] || 0;
  const diff = standardNum - standardNextStart;

  const p1 = 1.5, p2 = 1.25, p3 = 1, p4 = 0.75, p5 = 0.5;
  if (strandLeft === "-") {
    data.push([pointLeft[0], p3]);
    data.push([pointLeft[0] + leftLength / 4, p1]);
    data.push([pointLeft[0] + leftLength / 4, p2]);
    data.push([pointLeft[pointLeft.length - 1], p2]);
    data.push([pointLeft[pointLeft.length - 1], p4]);
    data.push([pointLeft[0] + leftLength / 4, p4]);
    data.push([pointLeft[0] + leftLength / 4, p5]);
  } else {
    data.push([pointLeft[0], p2]);
    data.push([pointLeft[pointLeft.length - 1] - leftLength / 4, p2]);
    data.push([pointLeft[pointLeft.length - 1] - leftLength / 4, p1]);
    data.push([pointLeft[pointLeft.length - 1], p3]);
    data.push([pointLeft[pointLeft.length - 1] - leftLength / 4, p5]);
    data.push([pointLeft[pointLeft.length - 1] - leftLength / 4, p4]);
    data.push([pointLeft[0], p4]);
  }
  return data;
}

util.getArrawRightData = (strand, pointLeft, pointRight) => {
  let data = [];
  const strandLeft = strand[0];
  const strandRight = strand[2]
  const leftLength = pointLeft[pointLeft.length - 1] - pointLeft[0];
  const rightLength = pointRight[pointRight.length - 1] - pointRight[0];
  const standardNum = pointLeft[pointLeft.length - 1] || 0;
  const standardNextStart = pointRight[0] || 0;
  const diff = standardNum - standardNextStart;

  const p1 = 1.5, p2 = 1.25, p3 = 1, p4 = 0.75, p5 = 0.5;
  if (strandRight === "-") {
    data.push([pointRight[0] + diff, p2]);
    data.push([pointRight[pointRight.length - 1] - rightLength / 4 + diff, p2]);
    data.push([pointRight[pointRight.length - 1] - rightLength / 4 + diff, p1]);
    data.push([pointRight[pointRight.length - 1] + diff, p3]);
    data.push([pointRight[pointRight.length - 1] - rightLength / 4 + diff, p5]);
    data.push([pointRight[pointRight.length - 1] - rightLength / 4 + diff, p4]);
    data.push([pointRight[0] + diff, p4]);
  } else {
    data.push([pointRight[0] + diff, p3]);
    data.push([pointRight[0] + rightLength / 4 + diff, p1]);
    data.push([pointRight[0] + rightLength / 4 + diff, p2]);
    data.push([pointRight[pointRight.length - 1] + diff, p2]);
    data.push([pointRight[pointRight.length - 1] + diff, p4]);
    data.push([pointRight[0] + rightLength / 4 + diff, p4]);
    data.push([pointRight[0] + rightLength / 4 + diff, p5]);
  }
  return data;
}

util.getArrawMatchLine = (pointLeft, pointRight) => {
  const standardNum = pointLeft[pointLeft.length - 1] || 0;
  const standardNextStart = pointRight[0] || 0;
  const diff = standardNum - standardNextStart;
  let line = [];
  const y = 1.5;
  const size = pointLeft.length + 1;
  for (let i = 0; i < pointLeft.length; i++) {
    let data = [];
    data.push([pointLeft[i], 1]);
    data.push([pointLeft[i], y + 0.5 / size * i]);
    data.push([pointRight[i] + diff, y + 0.5 / size * i]);
    data.push([pointRight[i] + diff, 1]);
    line.push({
      id: 'arraw_match_' + i,
      type: 'line',
      smooth: true,
      symbolSize: 0,
      data: data,
      color: '#5d01ff'
    });
  }
  return line;
}

util.getArrawRaioArea = (data, left, right, diff, startNum) => {
  let area = [];
  let len = data.length;
  let needDrawData = [];
  for (let i = 0; i < len - 1; i++) {
    let row = data[i].split("\t");
    let start = parseInt(row[1]) + diff;
    let end = parseInt(row[2]) + diff;
    let ratio = parseFloat(row[8]);
    if (start >= left && start <= right || end >= left && end <= right || start <= left && end >= right) {
      needDrawData.push([start, end, ratio]);
    }
  }
  let step = parseInt(Math.ceil(needDrawData.length / 100));
  for (let i = 0; i < needDrawData.length; i += step) {
    let start = Math.max(left, needDrawData[i][0]);
    let end = Math.min(right, needDrawData[i][1]);
    let color = "#E2775D";
    // console.log(start, startNum, diff);
    if (diff === 0) {
      color = "#E2775D";
    } else {
      color = "rgba(2,93,22,0.43)";
    }
    // if (diff === 0 && start > parseInt(startNum)) {
    //   continue;
    // }
    // if (diff !== 0 && start < parseInt(startNum)) {
    //   continue;
    // }
    area.push([start, end, needDrawData[i][2], color]);
  }
  return area;
}

util.getMergeSvsRatioArea = (left, right) => {
  let arr = left.concat(right).sort((i1, i2) => i1[0] - i2[0]);
  let res = [];
  if (arr.length === 1) {
    res.push([
      {
        coord: [arr[0][0], 1],
        symbolSize: 0,
        itemStyle: {
          color: arr[0][3]
        }
      },
      {
        coord: [arr[0][1], arr[0][2]],
        symbolSize: 0,
      }
    ]);
  } else {
    for (let i = 0; i < arr.length; i++) {
      // const s1 = arr[i][0], s2 = arr[i + 1][0];
      // const e1 = arr[i][1], e2 = arr[i + 1][1];
      // const r1 = arr[i][2], r2 = arr[i + 1][2];
      res.push([
        {
          coord: [arr[i][0], 1],
          symbolSize: 0,
          itemStyle: {
            color: arr[i][3]
          }
        },
        {
          coord: [arr[i][1], arr[i][2]],
          symbolSize: 0,
        }
      ]);
    }
  }

  return res;
}

util.randomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export default util



// WEBPACK FOOTER //
// ./src/libs/util.js